// components/ShiftList.jsx
import React, { useMemo, useState, useEffect, useCallback } from "react";

const ShiftList = ({
  value: propValue,            // selectedShift from parent (optional)
  onChange,                   // onSelect handler from parent (optional)
  loading: propLoading = false,
  emptyMessage = "Tidak ada data shift",
  shiftList: propShiftList,   // optional override of localStorage data
}) => {
  const [localShiftList, setLocalShiftList] = useState([]);
  const [localLoading, setLocalLoading] = useState(true);
  const [internalSelected, setInternalSelected] = useState(null);

  useEffect(() => {
    const loadShifts = () => {
      try {
        const data = localStorage.getItem("data_shift");
        if (data) {
          const parsed = JSON.parse(data);
          setLocalShiftList(Array.isArray(parsed) ? parsed : []);
        } else {
          setLocalShiftList([]);
        }
      } catch (err) {
        console.error("Gagal parse data_shift:", err);
        setLocalShiftList([]);
      } finally {
        setLocalLoading(false);
      }
    };

    loadShifts();
    const handleStorageChange = (e) => {
      if (e.key === "data_shift") loadShifts();
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const shiftList = propShiftList !== undefined ? propShiftList : localShiftList;
  const loading = propShiftList !== undefined ? propLoading : localLoading;

  // selectedShift: prefer propValue (controlled) else internal state (uncontrolled)
  const selectedShift = propValue !== undefined ? propValue : internalSelected;

  const handleSelect = useCallback(
    (item) => {
      // simpan ke localStorage juga (sikap backward-compatible)
      localStorage.setItem("shift_terpilih", JSON.stringify(item));

      if (onChange) {
        onChange(item);           // inform parent
      } else {
        setInternalSelected(item); // use internal state
      }
    },
    [onChange]
  );

  const renderList = useMemo(() => {
    if (loading) {
      return (
        <p style={{
          fontSize: 13,
          color: "#555",
          fontStyle: "italic",
          textAlign: "center",
          gridColumn: "1 / -1",
          margin: "20px 0",
        }}>
          Memuat shift...
        </p>
      );
    }

    if (!shiftList || shiftList.length === 0) {
      return (
        <p style={{
          fontSize: 13,
          color: "#555",
          fontStyle: "italic",
          textAlign: "center",
          gridColumn: "1 / -1",
          margin: "20px 0",
        }}>
          {emptyMessage}
        </p>
      );
    }

    return shiftList.map((item) => {
      const active = selectedShift && selectedShift.id === item.id;

      return (
        <div
          key={item.id}
          onClick={() => handleSelect(item)}
          style={{
            minWidth: 167,
            padding: "12px 16px",
            borderRadius: 16, // <<< GANTI DI SINI
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            cursor: "pointer",

            background: active
              ? "linear-gradient(135deg, #0099ff 0%, #0077cc 100%)"
              : "#ffffff",

            border: active
              ? "1px solid #0089e0"
              : "1px solid #e3eef7",

            boxShadow: active
              ? "0 4px 12px rgba(0, 123, 209, 0.25)"
              : "0 2px 6px rgba(0,0,0,0.05)",

            color: active ? "#fff" : "#222",
            transition: "all .25s ease",
          }}
        >
          <div style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: active ? "rgba(255,255,255,0.16)" : "#eaf5ff",
            fontSize: 16
          }}>
            {/* jam icon (Unicode) */}
            🕒
          </div>

          <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
          <span style={{ fontSize: 13, fontWeight: 700 }}>
            {item.shift_name || item.shift?.split(" ")[0] || "Shift"}
          </span>

          <span style={{ fontSize: 12, opacity: active ? 0.9 : 0.7 }}>
            {item.shift_time || item.shift?.split(" ").slice(1).join(" ") || ""}
          </span>
        </div>

          <div style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: active ? "rgba(255,255,255,0.16)" : "#eaf5ff",
            fontSize: 14
          }}>
            ↗
          </div>
        </div>
      );
    });
  }, [shiftList, selectedShift, loading, emptyMessage, handleSelect]);

  return <>{renderList}</>;
};

export default ShiftList;
